import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import { ADMIN_HTTP_STATUS, probeAdminAccess } from '@/lib/admin/client';
import { adminAccessQueryKey } from '@/lib/admin/queryKeys';

export function useAdminAccess(enabled: boolean) {
  const { getToken, sessionId, userId } = useAuth();
  const canProbe = enabled && !!userId && !!sessionId;

  return useQuery({
    queryKey: adminAccessQueryKey({ userId, sessionId }),
    enabled: canProbe,
    retry: false,
    queryFn: async () => {
      const token = await getToken();
      if (!token) {
        return ADMIN_HTTP_STATUS.UNAUTHORIZED;
      }
      return probeAdminAccess(token);
    },
  });
}
